var map = {
	"./atlaslogistics/slingco/logo.png": 2398,
	"./fsl/avi400/logo.png": 8756,
	"./kranlee/AMBLIMIT/logo.png": 4266,
	"./kranlee/FORB0001/logo.png": 8305,
	"./kranlee/FORBOFLO/logo.png": 505,
	"./kranlee/NORTHERN/logo.png": 6187,
	"./kranlee/ROBERLIM/logo.png": 767,
	"./kranlee/SCHENCKP/logo.png": 2032,
	"./kranlee/SPEEDPLA/logo.png": 4923,
	"./kranlee/TAYLORSE/logo.png": 5490,
	"./kranlee/TTSPRECI/logo.png": 7631,
	"./kranlee/intocast/logo.png": 2532,
	"./kranlee/shculcem/logo.png": 4529,
	"./kranlee/unipartr/logo.png": 5961,
	"./map/legacy/logo.png": 7784,
	"./webtest/andysana/logo.png": 9882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 460;